import { render, staticRenderFns } from "./addCustomer.vue?vue&type=template&id=9389a19c&scoped=true&"
import script from "./addCustomer.vue?vue&type=script&lang=js&"
export * from "./addCustomer.vue?vue&type=script&lang=js&"
import style0 from "./addCustomer.vue?vue&type=style&index=0&id=9389a19c&prod&lang=less&scoped=true&"
import style1 from "./addCustomer.vue?vue&type=style&index=1&id=9389a19c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9389a19c",
  null
  
)

export default component.exports